import { ReportApprovalStatus } from '@core/enums/report-approval-status';
import { MyReportApprovalListItem } from '@core/interfaces/my-report-approval-list-item';
import { createReducer, on } from '@ngrx/store';
import { MyItemsState } from '../my-items.state';
import { ApproveReport, CleanMyReportApprovals, RejectReport, SetMyReportApprovalLists } from '../actions/my-items.action';

const initialMyItems: MyItemsState = {
  reportApprovals: null,
};

export const myItemsActionReducer = createReducer(
  initialMyItems,
  on(
    SetMyReportApprovalLists,
    (
      state,
      { items },
    ): {
      reportApprovals: MyReportApprovalListItem[];
    } => ({ ...state, reportApprovals: items }),
  ),
  on(
    RejectReport,
    (
      state,
      { reportId },
    ): {
      reportApprovals: MyReportApprovalListItem[];
    } => ({ ...state, reportApprovals: rejectReport(reportId, state.reportApprovals) }),
  ),
  on(
    ApproveReport,
    (
      state,
      { reportId },
    ): {
      reportApprovals: MyReportApprovalListItem[];
    } => ({ ...state, reportApprovals: approveReport(reportId, state.reportApprovals) }),
  ),
  on(
    CleanMyReportApprovals,
    (
      state,
    ): {
      reportApprovals: any;
    } => ({ ...state, reportApprovals: null }),
  ),
);

const rejectReport = (payload: string, reports: MyReportApprovalListItem[]): MyReportApprovalListItem[] => {
  const reportIndex = reports.findIndex(r => r.inspectionReportApprovalId === payload);
  reports[reportIndex].status = ReportApprovalStatus.Rejected;
  return [...reports];
};

const approveReport = (payload: string, reports: MyReportApprovalListItem[]): MyReportApprovalListItem[] => {
  const reportIndex = reports.findIndex(r => r.inspectionReportApprovalId === payload);
  reports[reportIndex].status = ReportApprovalStatus.Signed;
  return [...reports];
};
